module.exports = __webpack_public_path__ + "static/logo101tissus-040f88fe150f432ee83f4cb8cec05dfa.png";